// @flow strict

import * as React from 'react'
import styles from './ComparisonTable.module.scss'
import greenTick from '../../../../static/images/icons/icon-green-check.svg'
import { AccessibilityText } from '@mondough/public-web-components'
import { prettyPrintPriceFromMinor } from '@mondough/public-web-components/src/utils/currencyUtils'

export type PaidFeaturesComparisonTableRow = {|
  name: string,
  core: boolean | string,
  holo: boolean | string,
  metal?: boolean | string,
|}

const Tick = () => (
  <>
    <AccessibilityText>Included</AccessibilityText>
    <img src={greenTick} alt="" />
  </>
)

const PaidBundlesComparisonTable = ({
  featuresTable,
  pricing,
  showPremium,
}: {|
  featuresTable: PaidFeaturesComparisonTableRow[],
  pricing: { core?: number, holo?: number, metal?: number, currency?: string },
  showPremium?: boolean,
|}) => (
  <table className={styles.comparisonTable}>
    <thead>
      <tr>
        <th>Feature</th>
        <th>Monzo</th>
        <th>Plus</th>
        {showPremium && <th>Premium</th>}
      </tr>
    </thead>
    <tbody>
      {featuresTable &&
        featuresTable.map(
          row =>
            row.name && (
              <tr key={row.name}>
                <td>{row.name}</td>
                <td>{row.core === true ? <Tick /> : row.core || ''}</td>
                <td>{row.holo === true ? <Tick /> : row.holo || ''}</td>
                {showPremium && (
                  <td>{row.metal === true ? <Tick /> : row.metal || ''}</td>
                )}
              </tr>
            ),
        )}
      {pricing.core != null && pricing.holo != null && pricing.metal != null && (
        <tr className={styles.priceRow}>
          <td>Price</td>
          <td>
            {pricing.core > 0 ? (
              <>
                {pricing.currency === 'GBP' ? <span>£</span> : ''}
                {prettyPrintPriceFromMinor(pricing.core) + ' per month'}
              </>
            ) : (
              'Free'
            )}
          </td>
          <td>
            {pricing.holo > 0 ? (
              <>
                {pricing.currency === 'GBP' ? <span>£</span> : ''}
                {prettyPrintPriceFromMinor(pricing.holo) + ' per month'}
              </>
            ) : (
              'Free'
            )}
          </td>
          {showPremium && pricing.metal != null && (
            <td>
              {pricing.metal > 0 ? (
                <>
                  {pricing.currency === 'GBP' ? <span>£</span> : ''}
                  {prettyPrintPriceFromMinor(pricing.metal) + ' per month'}
                </>
              ) : (
                'Free'
              )}
            </td>
          )}
        </tr>
      )}
    </tbody>
  </table>
)

export default PaidBundlesComparisonTable
